import { axios } from "../../../lib/axios";

export const getRelatedPersonByRef = (patientId) => {
    return axios.get(`relatedPerson?patientRefId=`, patientId);
}

// GET /patient/{id} expects the Patient table id (custom:patient_id), not the Person id.
export const getPatientDataForRelatedPerson = (patientRecordId) => {
    return axios.get(`patient/${patientRecordId}`);
}

export const rejectRelatedPerson = ({ id, userId }) => {
    return axios.delete(`relatedPerson?id=${id}&patientRefId=${userId}&isMobile=true`);
}

export const acceptRelatedPerson = (payload) => {
    return axios.put(`relatedPerson`, payload);
}